import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { WORKING_EQUIPMENT_PREFIX_URL } from './constants/config.working-equipment'

const ListPage = lazy(() => import('./pages/ListPage.WorkingEquipment'))

const WorkingEquipmentRouters: AppRouterItem[] = [
  {
    path: `${WORKING_EQUIPMENT_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default WorkingEquipmentRouters
